// extracted by mini-css-extract-plugin
export var grid = "grid-module--grid--e815d";
export var grid__1 = "grid-module--grid__1--9a5e8";
export var grid__2 = "grid-module--grid__2--418e2";
export var grid__3 = "grid-module--grid__3--c91cf";
export var grid__4 = "grid-module--grid__4--8b5db";
export var grid__5 = "grid-module--grid__5--49013";
export var grid__nowrap = "grid-module--grid__nowrap--9cae9";
export var grid__tight = "grid-module--grid__tight--81fdb";
export var spin = "grid-module--spin--56878";